import { useEffect } from "react";
import { FixFlipQuote } from "../quote";
import { observer } from "mobx-react";
import { useOneToolStore } from "../quote/hooks/useOneToolStore";
import { useParams } from 'react-router';

export const EditFixFlip = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { fixFlipQuoteStore } = oneToolStore;
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {

    fixFlipQuoteStore.loadQuoteToEdit(loanId);
  }, [fixFlipQuoteStore, loanId]);

  return (<FixFlipQuote />);
});